import { graphql } from "~/gql";

export const MATTER_TEMPLATE_LIST_ITEMS_QUERY = graphql(/* GraphQL */ `
  query FindMatterTemplateListItems(
    $search: String
    $offset: Float!
    $limit: Float!
    $templateType: TemplateType
    $orderBy: FilteredMattersOrderBy
    $orgUnitFilter: Float
  ) {
    matterTemplates(
      search: $search
      offset: $offset
      limit: $limit
      templateType: $templateType
      orderBy: $orderBy
      orgUnitFilter: $orgUnitFilter
    ) {
      items {
        ...MatterTemplateListItemParts
      }
      total
    }
  }
`);
